import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";

export default function AccountPage() {
  const [user, setUser] = useState(() => {
  const stored = localStorage.getItem("user");
  return stored ? JSON.parse(stored) : null;
});
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  // ✅ Fetch logged-in user info
 useEffect(() => {
  const fetchUser = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) return;

      const res = await axios.get("https://api.speedfollowinfo.com/api/user", {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (res.data?.success && res.data.user) {
        setUser(res.data.user);

        // ✅ localStorage আপডেট
        localStorage.setItem("user", JSON.stringify(res.data.user));
      }
    } catch (err) {
      console.error("❌ Fetch user error:", err.message);
    }
  };

  fetchUser();
}, []);

  // ✅ Password update handler
  const handlePasswordUpdate = async (e) => {
    e.preventDefault();

    if (!currentPassword || !newPassword || !confirmPassword) {
      return Swal.fire("⚠️ Missing Info", "Please fill in all fields.", "warning");
    }

    if (newPassword !== confirmPassword) {
      return Swal.fire("❌ Error", "New passwords do not match!", "error");
    }

    try {
      const token = localStorage.getItem("token");
      if (!token) {
        return Swal.fire(
          "🔒 Not authenticated",
          "Please log in to change your password.",
          "error"
        );
      }

      setLoading(true);

      // ✅ সঠিক backend endpoint এবং সঠিক field names
      const res = await axios.put(
        "https://api.speedfollowinfo.com/api/user/change-password",
        {
          currentPassword,
          newPassword,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      Swal.fire("✅ Success", res.data.message || "Password updated successfully!", "success");
      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");

      // ✅ লগ আউট করার সময় শুধু user-এর তথ্য মুছবে, admin-এর না
      setTimeout(() => {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        window.location.href = "/login";
      }, 2000);
    } catch (err) {
      console.error("❌ Change password error:", err);
      Swal.fire(
        "❌ Failed",
        err.response?.data?.message || "Password update failed!",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0b0f1a] text-white p-6">
      <h1 className="text-3xl font-bold text-[#ffd700] mb-6 text-center">
        👤 My Account
      </h1>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {/* 🔹 Left Section */}
        <div className="space-y-6">
          {/* User Info */}
          <div className="bg-[#161c34] p-5 rounded-xl shadow-lg">
            <h2 className="text-xl font-semibold mb-4 text-purple-400">
              User Infos
            </h2>
            <div className="mb-3">
              <label className="block text-gray-300 mb-1">Username</label>
              <input
                type="text"
                value={user?.username || ""}
                disabled
                className="w-full bg-[#1b2142] border border-[#2f3b6c] p-3 rounded text-gray-400"
              />
            </div>
            <div>
              <label className="block text-gray-300 mb-1">Email Address</label>
              <input
                type="text"
                value={user?.email || ""}
                disabled
                className="w-full bg-[#1b2142] border border-[#2f3b6c] p-3 rounded text-gray-400"
              />
            </div>
          </div>

          {/* Password Manager */}
          <div className="bg-[#161c34] p-5 rounded-xl shadow-lg">
            <h2 className="text-xl font-semibold mb-3 text-purple-400">
              Account Password Manager
            </h2>
            <form onSubmit={handlePasswordUpdate} className="space-y-4">
              <input
                type="password"
                placeholder="Current Password"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                className="w-full p-3 rounded bg-[#1b2142] border border-[#2f3b6c]"
              />
              <input
                type="password"
                placeholder="New Password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                className="w-full p-3 rounded bg-[#1b2142] border border-[#2f3b6c]"
              />
              <input
                type="password"
                placeholder="Confirm Password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                className="w-full p-3 rounded bg-[#1b2142] border border-[#2f3b6c]"
              />
              <button
                type="submit"
                disabled={loading}
                className={`w-full py-3 rounded-lg font-semibold hover:opacity-90 transition ${
                  loading
                    ? "bg-gray-600 cursor-not-allowed"
                    : "bg-gradient-to-r from-green-500 to-emerald-600"
                }`}
              >
                {loading ? "Processing..." : "Update Password"}
              </button>
            </form>
          </div>
        </div>

        {/* 🔹 Right Section */}
        <div className="space-y-6">
          {/* 2FA */}
          <div className="bg-[#161c34] p-5 rounded-xl shadow-lg">
            <h2 className="text-xl font-semibold mb-3 text-purple-400">
              Two-Factor Authentication
            </h2>
            <p className="text-gray-400 text-sm mb-3">
              2FA is currently disabled. Email-based 2FA adds an extra layer of security.
            </p>
            <button className="bg-gradient-to-r from-purple-500 to-indigo-600 w-full py-3 rounded-lg font-semibold hover:opacity-90">
              Enable 2FA
            </button>
          </div>

          {/* Timezone */}
          <div className="bg-[#161c34] p-5 rounded-xl shadow-lg">
            <h2 className="text-xl font-semibold mb-4 text-purple-400">Timezone</h2>
            <input
              type="text"
              value="Asia/Dhaka"
              disabled
              className="w-full bg-[#1b2142] border border-[#2f3b6c] p-3 rounded text-gray-300"
            />
            <button className="bg-gradient-to-r from-purple-500 to-indigo-600 w-full py-3 rounded-lg font-semibold hover:opacity-90 mt-3">
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}